import type { InjectionKey, Ref } from 'vue';

export const maxiNetCalendarContextKey: InjectionKey<{
  sessionDates: Ref<Set<string>>;
  sessionDatesLoading: Ref<boolean>;
  loadSessionDatesForMonth: (year: number, month: number) => void;
}> = Symbol('maxiNetCalendarContext');
